export default function getSearchUrl(currentUrl = "") {
  const parts = currentUrl.split("/");
  const hasCountryDomain = parts[1].length === 2;
  const baseUrl = hasCountryDomain
    ? `/${parts[1]}/${parts[2]}`
    : `/${parts[1]}`;

  return `${baseUrl}/search`;
}
